module.exports = __webpack_public_path__ + "static/img/16.909d7c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/16.jpg
// module id = n4Ka
// module chunks = 0